export default __webpack_public_path__ + "static/media/Microbusiness2.cd4cbbaa.png";